import { defineMessages } from 'react-intl';

export default defineMessages({
  printBoard: {
    id: 'cboard.components.PrintBoardButton.printBoard',
    defaultMessage: 'Print Board'
  },
  printBoardSecondary: {
    id: 'cboard.components.PrintBoardButton.printBoardSecondary',
    defaultMessage: 'Print current board (it can take a while).'
  },
  printCurrentBoard: {
    id: 'cboard.components.PrintBoardButton.printCurrentBoard',
    defaultMessage: 'Current Board'
  },
  printFullBoardSet: {
    id: 'cboard.components.PrintBoardButton.printFullBoardSet',
    defaultMessage: 'Full Board Set'
  },
  boardDownloaded: {
    id: 'cboard.components.PrintBoardButton.boardDownloaded',
    defaultMessage: 'Your board was downloaded'
  }
});
